export default __webpack_public_path__ + "static/media/tete14.981d72aa.png";